/**
 * 
 * Below is a list of hashed out modules and is tracked by core.
 * This is the only ts file which will be in core. Local project and can be editted by both.
 * Git will merge in new hashed lines from core as and when new modules are made.
 * Local project amends will be unhased lines; no other core.
 * 
 */

//import { anchorScroll } from "./core_modules/anchorScoll";
//import { eProtection } from "./core_modules/eProtection";
//import { getMediaQuery } from "./core_modules/checkMedia";

import startModule from "./core/startModule";

import * as custom from "./app";

/**
 * 
 * DO NOT EDIT ABOVE THIS LINE ON PROJECT (EXPECT FOR UNHASHING)
 * DO NOT EDIT BELOW THIS LINE ON CORE
 * 
 */

startModule(() => {
    custom.myApp
    // custom.myScript();
})






